var _a, _b;
import { UrlMappingsKeys } from '../url-mappings-keys';
import { mainMappingVariable } from '../../main-mapping-pattern';
export var groupMapping = (_a = {},
    _a[UrlMappingsKeys.GROUP] = {
        variables: ['groupId', 'tabName'],
        required: ['groupId', 'tabName'],
        subMappings: (_b = {},
            _b[UrlMappingsKeys.GROUP_POST] = {
                required: ['postId'],
                defaultMapping: mainMappingVariable + "/{{postId}}",
            },
            _b),
    },
    _a);
//# sourceMappingURL=group.js.map